export const OPERATION_CATEGORIES = {
  MATERIAL: 'material',
  OPERATION: 'operation',
} as const;

export const OPERATION_DEFINITION_CATEGORIES = {
  MATERIAL: 'material',
  OPERATION: 'operation',
} as const;
